const Header         = document.querySelector( '.header' );
const ToggleNav      = Header.querySelector( '.header__togglenav' );
const Navigation     = document.querySelector( '.navigation' );
const HeaderNav      = Header.querySelector( '.header__nav' );
const HeaderNavLinks = [].slice.call( HeaderNav.querySelectorAll( 'a' ) );
const IsHeaderInvert = Header.classList.contains( 'header--invert' );
const hasHeaderSocial = Header.querySelector( '.header__social' );
let lastScrollY      = 0;
let ticking          = null;


function Constructor() {
    if ( ToggleNav && Navigation ) {
        const NavigationClose = Navigation.querySelector( '.navigation__close' );
        ToggleNav.addEventListener( 'click', openNav, false );
        NavigationClose.addEventListener( 'click', closeNav, false );
    }

    HeaderNavLinks.forEach(element => {
        element.addEventListener( 'mouseenter', handleOver, false );
        element.addEventListener( 'mouseleave', handleOverOff, false );
    });

    window.addEventListener( 'load', onScroll, false );
    window.addEventListener( 'scroll', onScroll, false );
}

function handleOver( event ) {
    var el = this;
    var HeaderNavdesc = el.parentNode.querySelector( '.header__nav-desc' );

    if( !HeaderNavdesc ) return;
    if( HeaderNavdesc.classList.contains( 'hover' ) ) return;

    el.parentNode.classList.add( 'hover' );
}

function handleOverOff( e ) {
   this.parentNode.classList.remove( 'hover' );
}

function openNav() {
    Navigation.classList.add( 'navigation--active' );
    document.body.style.overflow = 'hidden';
}

function closeNav() {
    Navigation.classList.remove( 'navigation--active' );
    document.body.style.overflow = '';
}

function onScroll() {
    lastScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

    requestTick();
}

function requestTick() {
    if( !ticking ) {
        requestAnimationFrame( update );
        ticking = true;
    }
}

function update(){

    if ( lastScrollY > 10 ){
        Header.classList.add( 'header--sticky' );

        if( IsHeaderInvert ) {
            Header.classList.remove( 'header--invert' );
        }

        if( hasHeaderSocial ) {
            Header.classList.add( 'header--social' );
        }
    } else {
        Header.classList.remove( 'header--sticky' );

        if( IsHeaderInvert ) {
            Header.classList.add( 'header--invert' );
        }

        if( hasHeaderSocial ) {
            Header.classList.remove( 'header--social' );
        }
    }

    ticking = false;
}

export default Constructor;